// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__y2Nr4","tab":"Tabs_tab__3a6Dh","active":"Tabs_active__aKMuL"};